import { render, staticRenderFns } from "./StaffDM.vue?vue&type=template&id=37c56e8c&scoped=true"
import script from "./StaffDM.vue?vue&type=script&lang=js"
export * from "./StaffDM.vue?vue&type=script&lang=js"
import style0 from "./StaffDM.vue?vue&type=style&index=0&id=37c56e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c56e8c",
  null
  
)

export default component.exports